import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ReactComponent as PrevMessage } from '../../assets/images/prev-message.svg';
import { RootState } from '../../features';
import { interpolateFreeText } from '../../i18n';
import { replaceAllSpaces } from '../../lib/utils';

export const PreviousMessageButton: React.FC<{
  message: string;
  onClick: () => void;
}> = ({ message, onClick }) => {
  const { isSending } = useSelector((state: RootState) => state.chat);
  const { t } = useTranslation('chat');
  return (
    <button
      disabled={isSending}
      onClick={onClick}
      aria-label={interpolateFreeText(t, 'aria_prev_message', 'message', message)}
      className={css`
        display: flex;
        align-items: center;
        max-width: 200px;
        height: 44px;
        font-size: 12px;
        color: #938666;
        background: #f5f1e3;
        border: 4px solid white;
        border-radius: 22px;
        margin: 10px 0;
        padding: 0 12px;
        .icon {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .text {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin: 0 0 0 8px;
        }
      `}
    >
      <span className="icon">
        <PrevMessage />
      </span>
      {/* to show space */}
      <span className="text">{replaceAllSpaces(message)}</span>
    </button>
  );
};
